import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

// `previousDisabled` exists so the audit log records the transition, not just
// the new value; verifying it against the row keeps the log truthful and
// rejects a toggle racing another admin's change.
export const setPublicRouteAuthDisabledSchema = z.object({
  disabled: z.boolean(),
  previousDisabled: z.boolean(),
});

export const setPublicRouteAuthDisabled = mutator({
  schema: setPublicRouteAuthDisabledSchema,
  resolve: {},
  permissions: [
    { permission: "allow_all", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args: { disabled, previousDisabled } }) => {
    const tenant = await tx.run(zql.tenants.where("id", ctx.tenantId).one());
    if ((tenant?.publicRouteAuthDisabled ?? false) !== previousDisabled) {
      throw userFacingError(
        "The setting changed since you loaded it — try again"
      );
    }
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      publicRouteAuthDisabled: disabled,
      updatedAt: Date.now(),
    });
  },
});
